module.exports = __webpack_public_path__ + "img/arrow_down.0c513203.svg";